export default "__VITE_ASSET__1a7db556__"